(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib-js-ir.js', './kotlinx-serialization-kotlinx-serialization-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib-js-ir.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'metron-fleks'. Its dependency 'kotlin-kotlin-stdlib-js-ir' was not found. Please, check whether 'kotlin-kotlin-stdlib-js-ir' is loaded prior to 'metron-fleks'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'metron-fleks'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'metron-fleks'.");
    }
    root['metron-fleks'] = factory(typeof this['metron-fleks'] === 'undefined' ? {} : this['metron-fleks'], this['kotlin-kotlin-stdlib-js-ir'], this['kotlinx-serialization-kotlinx-serialization-core']);
  }
}(this, function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.yc;
  var copyOf = kotlin_kotlin.$_$.y6;
  var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.w1;
  var NoSuchElementException_init_$Create$ = kotlin_kotlin.$_$.y1;
  var classMeta = kotlin_kotlin.$_$.lb;
  var VOID = kotlin_kotlin.$_$.ni;
  var setMetadataFor = kotlin_kotlin.$_$.zc;
  var longArray = kotlin_kotlin.$_$.pc;
  var Long = kotlin_kotlin.$_$.ug;
  var copyOf_0 = kotlin_kotlin.$_$.s6;
  var fill = kotlin_kotlin.$_$.g7;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.h1;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.h2;
  var charArrayOf = kotlin_kotlin.$_$.gb;
  var trimEnd = kotlin_kotlin.$_$.eg;
  var isBlank = kotlin_kotlin.$_$.pe;
  var fillArrayVal = kotlin_kotlin.$_$.qb;
  var arrayCopy = kotlin_kotlin.$_$.w5;
  var fill_0 = kotlin_kotlin.$_$.j7;
  var getKClassFromExpression = kotlin_kotlin.$_$.d;
  var THROW_CCE = kotlin_kotlin.$_$.ah;
  var contentHashCode = kotlin_kotlin.$_$.m6;
  var Unit_getInstance = kotlin_kotlin.$_$.a5;
  var objectMeta = kotlin_kotlin.$_$.xc;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.ii;
  var toString = kotlin_kotlin.$_$.dd;
  var substringAfterLast = kotlin_kotlin.$_$.hf;
  var substringBefore = kotlin_kotlin.$_$.lf;
  var InlineClassDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w1;
  var IntSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var ArrayDeque_init_$Create$ = kotlin_kotlin.$_$.k;
  var captureStack = kotlin_kotlin.$_$.fb;
  var getKClass = kotlin_kotlin.$_$.e;
  var RuntimeException = kotlin_kotlin.$_$.zg;
  var RuntimeException_init_$Init$ = kotlin_kotlin.$_$.a2;
  var equals = kotlin_kotlin.$_$.ob;
  var hashCode = kotlin_kotlin.$_$.xb;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.di;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.v;
  var copyToArray = kotlin_kotlin.$_$.a7;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.m;
  var Collection = kotlin_kotlin.$_$.e5;
  var isInterface = kotlin_kotlin.$_$.jc;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Bag, 'Bag', classMeta);
  setMetadataFor(BitArray, 'BitArray', classMeta);
  setMetadataFor(MutableEntityBag, 'MutableEntityBag', classMeta);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(ComponentType, 'ComponentType', classMeta);
  setMetadataFor(ComponentService, 'ComponentService', classMeta);
  setMetadataFor(ComponentsHolder, 'ComponentsHolder', classMeta);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Entity, 'Entity', classMeta, VOID, VOID, VOID, {0: $serializer_getInstance});
  setMetadataFor(EntityComponentContext, 'EntityComponentContext', classMeta);
  setMetadataFor(EntityCreateContext, 'EntityCreateContext', classMeta, EntityComponentContext);
  setMetadataFor(EntityService, 'EntityService', classMeta);
  setMetadataFor(EntityUpdateContext, 'EntityUpdateContext', classMeta, EntityCreateContext);
  setMetadataFor(DefaultEntityProvider, 'DefaultEntityProvider', classMeta);
  setMetadataFor(FleksException, 'FleksException', classMeta, RuntimeException);
  setMetadataFor(FleksHookAlreadyAddedException, 'FleksHookAlreadyAddedException', classMeta, FleksException);
  setMetadataFor(FleksFamilyException, 'FleksFamilyException', classMeta, FleksException);
  setMetadataFor(FleksWrongConfigurationUsageException, 'FleksWrongConfigurationUsageException', classMeta, FleksException);
  setMetadataFor(FleksSystemAlreadyAddedException, 'FleksSystemAlreadyAddedException', classMeta, FleksException);
  setMetadataFor(FleksNoSuchEntityComponentException, 'FleksNoSuchEntityComponentException', classMeta, FleksException);
  setMetadataFor(Family, 'Family', classMeta, EntityComponentContext);
  setMetadataFor(FamilyDefinition, 'FamilyDefinition', classMeta);
  setMetadataFor(IteratingSystem$Companion$EMPTY_COMPARATOR$1, VOID, classMeta);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor(IntervalSystem, 'IntervalSystem', classMeta, EntityComponentContext);
  setMetadataFor(IteratingSystem, 'IteratingSystem', classMeta, IntervalSystem);
  setMetadataFor(EachFrame, 'EachFrame', objectMeta);
  setMetadataFor(Automatic, 'Automatic', objectMeta);
  setMetadataFor(Fixed, 'Fixed', classMeta);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor(World, 'World', classMeta, EntityComponentContext);
  setMetadataFor(WorldConfiguration, 'WorldConfiguration', classMeta);
  setMetadataFor(ComponentConfiguration, 'ComponentConfiguration', classMeta);
  setMetadataFor(SystemConfiguration, 'SystemConfiguration', classMeta);
  setMetadataFor(InjectableConfiguration, 'InjectableConfiguration', classMeta);
  setMetadataFor(FamilyConfiguration, 'FamilyConfiguration', classMeta);
  //endregion
  function Bag(values) {
    this.ef2_1 = values;
    this.ff2_1 = 0;
  }
  protoOf(Bag).gf2 = function () {
    return this.ef2_1.length;
  };
  protoOf(Bag).hf2 = function (index, value) {
    if (index >= this.ef2_1.length) {
      var tmp = this;
      var tmp_0 = this.ef2_1;
      var tmp$ret$0;
      // Inline function 'kotlin.math.max' call
      var tmp0_max = imul(this.ff2_1, 2);
      var tmp1_max = index + 1 | 0;
      tmp$ret$0 = Math.max(tmp0_max, tmp1_max);
      tmp.ef2_1 = copyOf(tmp_0, tmp$ret$0);
    }
    var tmp_1 = this;
    // Inline function 'kotlin.math.max' call
    var tmp2_max = this.ff2_1;
    var tmp3_max = index + 1 | 0;
    tmp_1.ff2_1 = Math.max(tmp2_max, tmp3_max);
    this.ef2_1[index] = value;
  };
  protoOf(Bag).k = function (index) {
    if (index < 0 ? true : index >= this.ff2_1)
      throw IndexOutOfBoundsException_init_$Create$('' + index + ' is not valid for bag of size ' + this.ff2_1);
    var _elvis__6sfipt = this.ef2_1[index];
    var tmp;
    if (_elvis__6sfipt == null) {
      throw NoSuchElementException_init_$Create$('Bag has no value at index ' + index);
    } else {
      tmp = _elvis__6sfipt;
    }
    return tmp;
  };
  protoOf(Bag).if2 = function (index) {
    return index >= this.ff2_1 ? true : this.ef2_1[index] == null;
  };
  function BitArray(nBits) {
    nBits = nBits === VOID ? 0 : nBits;
    this.jf2_1 = longArray((nBits + 63 | 0) / 64 | 0);
  }
  protoOf(BitArray).kf2 = function () {
    var inductionVariable = this.jf2_1.length - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var word = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        if (!this.jf2_1[word].equals(new Long(0, 0)))
          return true;
      }
       while (0 <= inductionVariable);
    return false;
  };
  protoOf(BitArray).lf2 = function () {
    return !this.kf2();
  };
  protoOf(BitArray).k = function (idx) {
    var word = idx / 64 | 0;
    return word >= this.jf2_1.length ? false : !this.jf2_1[word].ea((new Long(1, 0)).u8(idx % 64 | 0)).equals(new Long(0, 0));
  };
  protoOf(BitArray).mf2 = function (idx) {
    var word = idx / 64 | 0;
    if (word >= this.jf2_1.length) {
      this.jf2_1 = copyOf_0(this.jf2_1, word + 1 | 0);
    }
    this.jf2_1[word] = this.jf2_1[word].mi((new Long(1, 0)).u8(idx % 64 | 0));
  };
  protoOf(BitArray).nf2 = function () {
    fill(this.jf2_1, new Long(0, 0));
  };
  protoOf(BitArray).r7m = function (idx) {
    var word = idx / 64 | 0;
    if (word < this.jf2_1.length) {
      this.jf2_1[word] = this.jf2_1[word].ea((new Long(1, 0)).u8(idx % 64 | 0).li());
    }
  };
  protoOf(BitArray).of2 = function (other) {
    var otherBits = other.jf2_1;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = this.jf2_1.length;
    var tmp1_min = otherBits.length;
    var start = Math.min(tmp0_min, tmp1_min) - 1 | 0;
    var inductionVariable = start;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        if (!this.jf2_1[i].ea(otherBits[i]).equals(new Long(0, 0)))
          return true;
      }
       while (0 <= inductionVariable);
    return false;
  };
  protoOf(BitArray).pf2 = function (other) {
    var otherBits = other.jf2_1;
    var inductionVariable = this.jf2_1.length;
    var last = otherBits.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!otherBits[i].equals(new Long(0, 0)))
          return false;
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.math.min' call
    var tmp0_min = this.jf2_1.length;
    var tmp1_min = otherBits.length;
    var start = Math.min(tmp0_min, tmp1_min) - 1 | 0;
    var inductionVariable_0 = start;
    if (0 <= inductionVariable_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + -1 | 0;
        if (!this.jf2_1[i_0].ea(otherBits[i_0]).equals(otherBits[i_0]))
          return false;
      }
       while (0 <= inductionVariable_0);
    return true;
  };
  protoOf(BitArray).qf2 = function () {
    var inductionVariable = this.jf2_1.length - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var word = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var bitsAtWord = this.jf2_1[word];
        if (!bitsAtWord.equals(new Long(0, 0))) {
          var w = word << 6;
          var inductionVariable_0 = 63;
          if (0 <= inductionVariable_0)
            do {
              var bit = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + -1 | 0;
              if (!bitsAtWord.ea((new Long(1, 0)).u8(bit)).equals(new Long(0, 0)))
                return (w + bit | 0) + 1 | 0;
            }
             while (0 <= inductionVariable_0);
        }
      }
       while (0 <= inductionVariable);
    return 0;
  };
  protoOf(BitArray).rf2 = function () {
    var sum = 0;
    var inductionVariable = this.jf2_1.length - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var word = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var bitsAtWord = this.jf2_1[word];
        if (!bitsAtWord.equals(new Long(0, 0))) {
          var inductionVariable_0 = 63;
          if (0 <= inductionVariable_0)
            do {
              var bit = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + -1 | 0;
              if (!bitsAtWord.ea((new Long(1, 0)).u8(bit)).equals(new Long(0, 0))) {
                sum = sum + 1 | 0;
              }
            }
             while (0 <= inductionVariable_0);
        }
      }
       while (0 <= inductionVariable);
    return sum;
  };
  protoOf(BitArray).sf2 = function (bag) {
    var checkSize = true;
    bag.y2();
    // Inline function 'com.github.quillraven.fleks.collection.BitArray.forEachSetBit' call
    var inductionVariable = this.jf2_1.length - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var word = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var bitsAtWord = this.jf2_1[word];
        if (!bitsAtWord.equals(new Long(0, 0))) {
          var w = word << 6;
          var inductionVariable_0 = 63;
          if (0 <= inductionVariable_0)
            do {
              var bit = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + -1 | 0;
              if (!bitsAtWord.ea((new Long(1, 0)).u8(bit)).equals(new Long(0, 0))) {
                // Inline function 'com.github.quillraven.fleks.collection.BitArray.toEntityBag.<anonymous>' call
                var tmp0_anonymous = w + bit | 0;
                if (checkSize) {
                  checkSize = false;
                  bag.hc(tmp0_anonymous);
                }
                bag.vf2(_Entity___init__impl__fl94im(tmp0_anonymous));
              }
            }
             while (0 <= inductionVariable_0);
        }
      }
       while (0 <= inductionVariable);
  };
  protoOf(BitArray).hashCode = function () {
    // Inline function 'kotlin.collections.isEmpty' call
    if (this.jf2_1.length === 0)
      return 0;
    var word = this.qf2() / 64 | 0;
    var hash = 0;
    var inductionVariable = 0;
    if (inductionVariable <= word)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        hash = imul(127, hash) + this.jf2_1[i].f7(this.jf2_1[i].e7(32)).e1() | 0;
      }
       while (!(i === word));
    return hash;
  };
  protoOf(BitArray).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BitArray))
      return false;
    var otherBits = other.jf2_1;
    // Inline function 'kotlin.math.min' call
    var tmp0_min = this.jf2_1.length;
    var tmp1_min = otherBits.length;
    var commonWords = Math.min(tmp0_min, tmp1_min);
    var inductionVariable = 0;
    if (inductionVariable < commonWords)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!this.jf2_1[i].equals(otherBits[i]))
          return false;
      }
       while (inductionVariable < commonWords);
    return this.jf2_1.length === otherBits.length ? true : this.qf2() === other.qf2();
  };
  protoOf(BitArray).toString = function () {
    // Inline function 'kotlin.text.ifBlank' call
    var tmp$ret$1;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var tmp0_apply = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.github.quillraven.fleks.collection.BitArray.toString.<anonymous>' call
    var indexedObject = this.jf2_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var bitsAtWord = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (!bitsAtWord.equals(new Long(0, 0))) {
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 64)
          do {
            var bit = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!bitsAtWord.ea((new Long(1, 0)).u8(bit)).equals(new Long(0, 0)))
              tmp0_apply.p8('1');
            else
              tmp0_apply.p8('0');
          }
           while (inductionVariable_0 < 64);
      } else {
        // Inline function 'kotlin.repeat' call
        // Inline function 'kotlin.contracts.contract' call
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 64)
          do {
            var index = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            // Inline function 'com.github.quillraven.fleks.collection.BitArray.toString.<anonymous>.<anonymous>' call
            tmp0_apply.p8('0');
          }
           while (inductionVariable_1 < 64);
      }
    }
    tmp$ret$1 = tmp0_apply.toString();
    var tmp0_ifBlank = trimEnd(tmp$ret$1, charArrayOf([_Char___init__impl__6a9atx(48)]));
    var tmp;
    if (isBlank(tmp0_ifBlank)) {
      // Inline function 'com.github.quillraven.fleks.collection.BitArray.toString.<anonymous>' call
      tmp = '0';
    } else {
      tmp = tmp0_ifBlank;
    }
    return tmp;
  };
  function isNullOrEmpty(_this__u8e3s4) {
    return _this__u8e3s4 == null ? true : _this__u8e3s4.lf2();
  }
  function MutableEntityBag$containsAll$lambda(this$0) {
    return function (it) {
      return this$0.xf2(it.wf2_1);
    };
  }
  function MutableEntityBag(size) {
    size = size === VOID ? 64 : size;
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(size), null);
    while (tmp_0 < size) {
      var tmp_2 = tmp_0;
      var tmp$ret$1;
      tmp$ret$1 = _Entity___init__impl__fl94im(-1);
      tmp_1[tmp_2] = new Entity(tmp$ret$1);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.tf2_1 = tmp_1;
    this.uf2_1 = 0;
  }
  protoOf(MutableEntityBag).vf2 = function (entity) {
    if (this.uf2_1 === this.tf2_1.length) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyInto' call
      var tmp1_copyInto = this.tf2_1;
      var tmp_0 = 0;
      // Inline function 'kotlin.math.max' call
      var tmp0_max = imul(this.uf2_1, 2);
      var tmp_1 = Math.max(1, tmp0_max);
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_2 = fillArrayVal(Array(tmp_1), null);
      while (tmp_0 < tmp_1) {
        var tmp_3 = tmp_0;
        var tmp$ret$2;
        tmp$ret$2 = _Entity___init__impl__fl94im(-1);
        tmp_2[tmp_3] = new Entity(tmp$ret$2);
        tmp_0 = tmp_0 + 1 | 0;
      }
      var tmp3_copyInto = tmp1_copyInto.length;
      arrayCopy(tmp1_copyInto, tmp_2, 0, 0, tmp3_copyInto);
      tmp.tf2_1 = tmp_2;
    }
    var tmp_4 = this.tf2_1;
    var _unary__edvuaz = this.uf2_1;
    this.uf2_1 = _unary__edvuaz + 1 | 0;
    tmp_4[_unary__edvuaz] = new Entity(entity);
  };
  protoOf(MutableEntityBag).y2 = function () {
    fill_0(this.tf2_1, new Entity(_Entity___init__impl__fl94im(-1)));
    this.uf2_1 = 0;
  };
  protoOf(MutableEntityBag).hc = function (capacity) {
    if (capacity >= this.tf2_1.length) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyInto' call
      var tmp0_copyInto = this.tf2_1;
      var tmp_0 = 0;
      var tmp_1 = capacity + 1 | 0;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_2 = fillArrayVal(Array(tmp_1), null);
      while (tmp_0 < tmp_1) {
        var tmp_3 = tmp_0;
        var tmp$ret$1;
        tmp$ret$1 = _Entity___init__impl__fl94im(-1);
        tmp_2[tmp_3] = new Entity(tmp$ret$1);
        tmp_0 = tmp_0 + 1 | 0;
      }
      var tmp2_copyInto = tmp0_copyInto.length;
      arrayCopy(tmp0_copyInto, tmp_2, 0, 0, tmp2_copyInto);
      tmp.tf2_1 = tmp_2;
    }
  };
  protoOf(MutableEntityBag).yf2 = function (comparator) {
    quickSort(this.tf2_1, 0, this.uf2_1, comparator);
  };
  protoOf(MutableEntityBag).xf2 = function (entity) {
    var inductionVariable = 0;
    var last = this.uf2_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.tf2_1[i].equals(new Entity(entity)))
          return true;
      }
       while (inductionVariable < last);
    return false;
  };
  protoOf(MutableEntityBag).zf2 = function (entities) {
    return entities.af3(MutableEntityBag$containsAll$lambda(this));
  };
  protoOf(MutableEntityBag).k17 = function () {
    return this.uf2_1 > 0;
  };
  protoOf(MutableEntityBag).af3 = function (predicate) {
    var inductionVariable = 0;
    var last = this.uf2_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!predicate(this.tf2_1[i]))
          return false;
      }
       while (inductionVariable < last);
    return true;
  };
  protoOf(MutableEntityBag).bf3 = function (action) {
    var inductionVariable = 0;
    var last = this.uf2_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        action(this.tf2_1[i]);
      }
       while (inductionVariable < last);
  };
  protoOf(MutableEntityBag).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof MutableEntityBag))
      THROW_CCE();
    if (!(this.uf2_1 === other.uf2_1))
      return false;
    return this.zf2(other);
  };
  protoOf(MutableEntityBag).hashCode = function () {
    var result = contentHashCode(this.tf2_1);
    result = imul(31, result) + this.uf2_1 | 0;
    return result;
  };
  function quickSort(_this__u8e3s4, fromIdx, toIdx, comparator) {
    var len = toIdx - fromIdx | 0;
    if (len < 7) {
      selectionSort(_this__u8e3s4, fromIdx, toIdx, comparator);
      return Unit_getInstance();
    }
    var m = fromIdx + (len / 2 | 0) | 0;
    if (len > 7) {
      var l = fromIdx;
      var n = toIdx - 1 | 0;
      if (len > 50) {
        var s = len / 8 | 0;
        l = med3(_this__u8e3s4, l, l + s | 0, l + imul(2, s) | 0, comparator);
        m = med3(_this__u8e3s4, m - s | 0, m, m + s | 0, comparator);
        n = med3(_this__u8e3s4, n - imul(2, s) | 0, n - s | 0, n, comparator);
      }
      m = med3(_this__u8e3s4, l, m, n, comparator);
    }
    var v = _this__u8e3s4[m].wf2_1;
    var a = fromIdx;
    var b = a;
    var c = toIdx - 1 | 0;
    var d = c;
    $l$loop_1: while (true) {
      var comparison = 0;
      $l$loop: while (true) {
        var tmp;
        if (b <= c) {
          // Inline function 'kotlin.also' call
          var tmp0_also = comparator.cf3(_this__u8e3s4[b].wf2_1, v);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.github.quillraven.fleks.collection.quickSort.<anonymous>' call
          comparison = tmp0_also;
          tmp = tmp0_also <= 0;
        } else {
          tmp = false;
        }
        if (!tmp) {
          break $l$loop;
        }
        if (comparison === 0) {
          var _unary__edvuaz = a;
          a = _unary__edvuaz + 1 | 0;
          swap(_this__u8e3s4, _unary__edvuaz, b);
        }
        b = b + 1 | 0;
      }
      $l$loop_0: while (true) {
        var tmp_0;
        if (c >= b) {
          // Inline function 'kotlin.also' call
          var tmp1_also = comparator.cf3(_this__u8e3s4[c].wf2_1, v);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.github.quillraven.fleks.collection.quickSort.<anonymous>' call
          comparison = tmp1_also;
          tmp_0 = tmp1_also >= 0;
        } else {
          tmp_0 = false;
        }
        if (!tmp_0) {
          break $l$loop_0;
        }
        if (comparison === 0) {
          var tmp_1 = c;
          var _unary__edvuaz_0 = d;
          d = _unary__edvuaz_0 - 1 | 0;
          swap(_this__u8e3s4, tmp_1, _unary__edvuaz_0);
        }
        c = c - 1 | 0;
      }
      if (b > c)
        break $l$loop_1;
      var _unary__edvuaz_1 = b;
      b = _unary__edvuaz_1 + 1 | 0;
      var _unary__edvuaz_2 = c;
      c = _unary__edvuaz_2 - 1 | 0;
      swap(_this__u8e3s4, _unary__edvuaz_1, _unary__edvuaz_2);
    }
    // Inline function 'kotlin.math.min' call
    var tmp2_min = a - fromIdx | 0;
    var tmp3_min = b - a | 0;
    var s_0 = Math.min(tmp2_min, tmp3_min);
    vecSwap(_this__u8e3s4, fromIdx, b - s_0 | 0, s_0);
    // Inline function 'kotlin.math.min' call
    var tmp4_min = d - c | 0;
    var tmp5_min = (toIdx - d | 0) - 1 | 0;
    s_0 = Math.min(tmp4_min, tmp5_min);
    vecSwap(_this__u8e3s4, b, toIdx - s_0 | 0, s_0);
    // Inline function 'kotlin.also' call
    var tmp6_also = b - a | 0;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.github.quillraven.fleks.collection.quickSort.<anonymous>' call
    s_0 = tmp6_also;
    if (tmp6_also > 1) {
      quickSort(_this__u8e3s4, fromIdx, fromIdx + s_0 | 0, comparator);
    }
    // Inline function 'kotlin.also' call
    var tmp7_also = d - c | 0;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.github.quillraven.fleks.collection.quickSort.<anonymous>' call
    s_0 = tmp7_also;
    if (tmp7_also > 1) {
      quickSort(_this__u8e3s4, toIdx - s_0 | 0, toIdx, comparator);
    }
  }
  function selectionSort(_this__u8e3s4, fromIdx, toIdx, comparator) {
    var inductionVariable = fromIdx;
    var last = toIdx - 1 | 0;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var m = i;
        var inductionVariable_0 = i + 1 | 0;
        if (inductionVariable_0 < toIdx)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (comparator.cf3(_this__u8e3s4[j].wf2_1, _this__u8e3s4[m].wf2_1) < 0) {
              m = j;
            }
          }
           while (inductionVariable_0 < toIdx);
        if (!(m === i)) {
          swap(_this__u8e3s4, i, m);
        }
      }
       while (inductionVariable < last);
  }
  function med3(_this__u8e3s4, idxA, idxB, idxC, comparator) {
    var ab = comparator.cf3(_this__u8e3s4[idxA].wf2_1, _this__u8e3s4[idxB].wf2_1);
    var ac = comparator.cf3(_this__u8e3s4[idxA].wf2_1, _this__u8e3s4[idxC].wf2_1);
    var bc = comparator.cf3(_this__u8e3s4[idxB].wf2_1, _this__u8e3s4[idxC].wf2_1);
    return ab < 0 ? bc < 0 ? idxB : ac < 0 ? idxC : idxA : bc > 0 ? idxB : ac > 0 ? idxC : idxA;
  }
  function swap(_this__u8e3s4, idxA, idxB) {
    var tmp = _this__u8e3s4[idxA].wf2_1;
    _this__u8e3s4[idxA] = _this__u8e3s4[idxB];
    _this__u8e3s4[idxB] = new Entity(tmp);
  }
  function vecSwap(_this__u8e3s4, idxA, idxB, n) {
    var a = idxA;
    var b = idxB;
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _unary__edvuaz = a;
        a = _unary__edvuaz + 1 | 0;
        var _unary__edvuaz_0 = b;
        b = _unary__edvuaz_0 + 1 | 0;
        swap(_this__u8e3s4, _unary__edvuaz, _unary__edvuaz_0);
      }
       while (inductionVariable < n);
  }
  function Companion() {
    Companion_instance = this;
    this.df3_1 = 0;
  }
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function ComponentType() {
    Companion_getInstance();
    var tmp = this;
    var _unary__edvuaz = Companion_getInstance().df3_1;
    Companion_getInstance().df3_1 = _unary__edvuaz + 1 | 0;
    tmp.ef3_1 = _unary__edvuaz;
  }
  function ComponentService() {
    var tmp = this;
    // Inline function 'com.github.quillraven.fleks.collection.bag' call
    var tmp$ret$0;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp$ret$0 = fillArrayVal(Array(64), null);
    tmp.gf3_1 = new Bag(tmp$ret$0);
  }
  protoOf(ComponentService).hf3 = function () {
    var tmp = this.ff3_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('world');
    }
  };
  protoOf(ComponentService).if3 = function (_this__u8e3s4) {
    return substringBefore(substringAfterLast(toString(_this__u8e3s4), '.'), '$');
  };
  protoOf(ComponentService).jf3 = function (index) {
    return this.gf3_1.k(index);
  };
  function ComponentsHolder(world, name, components) {
    this.kf3_1 = world;
    this.lf3_1 = name;
    this.mf3_1 = components;
    this.nf3_1 = null;
    this.of3_1 = null;
  }
  protoOf(ComponentsHolder).pf3 = function (entity, component) {
    if (_Entity___get_id__impl__z2xerk(entity) >= this.mf3_1.length) {
      var tmp = this;
      var tmp_0 = this.mf3_1;
      var tmp$ret$0;
      // Inline function 'kotlin.math.max' call
      var tmp0_max = imul(this.mf3_1.length, 2);
      var tmp1_max = _Entity___get_id__impl__z2xerk(entity) + 1 | 0;
      tmp$ret$0 = Math.max(tmp0_max, tmp1_max);
      tmp.mf3_1 = copyOf(tmp_0, tmp$ret$0);
    }
    var tmp3_safe_receiver = this.mf3_1[_Entity___get_id__impl__z2xerk(entity)];
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.github.quillraven.fleks.ComponentsHolder.set.<anonymous>' call
      this.mf3_1[_Entity___get_id__impl__z2xerk(entity)] = null;
      var tmp4_safe_receiver = this.of3_1;
      tmp4_safe_receiver == null || tmp4_safe_receiver(this.kf3_1, new Entity(entity), tmp3_safe_receiver);
    }
    this.mf3_1[_Entity___get_id__impl__z2xerk(entity)] = component;
    var tmp5_safe_receiver = this.nf3_1;
    if (tmp5_safe_receiver == null)
      null;
    else
      tmp5_safe_receiver(this.kf3_1, new Entity(entity), component);
  };
  protoOf(ComponentsHolder).qf3 = function (entity) {
    if (_Entity___get_id__impl__z2xerk(entity) < 0 ? true : _Entity___get_id__impl__z2xerk(entity) >= this.mf3_1.length)
      throw IndexOutOfBoundsException_init_$Create$('' + new Entity(entity) + '.id is not valid for components of size ' + this.mf3_1.length);
    var existingCmp = this.mf3_1[_Entity___get_id__impl__z2xerk(entity)];
    this.mf3_1[_Entity___get_id__impl__z2xerk(entity)] = null;
    if (!(existingCmp == null)) {
      var tmp6_safe_receiver = this.of3_1;
      if (tmp6_safe_receiver == null)
        null;
      else
        tmp6_safe_receiver(this.kf3_1, new Entity(entity), existingCmp);
    }
  };
  protoOf(ComponentsHolder).rf3 = function (entity) {
    var _elvis__6sfipt = this.mf3_1[_Entity___get_id__impl__z2xerk(entity)];
    var tmp;
    if (_elvis__6sfipt == null) {
      throw new FleksNoSuchEntityComponentException(entity, this.lf3_1);
    } else {
      tmp = _elvis__6sfipt;
    }
    return tmp;
  };
  protoOf(ComponentsHolder).toString = function () {
    return 'ComponentsHolder(' + this.lf3_1 + ')';
  };
  function _Entity___init__impl__fl94im(id) {
    return id;
  }
  function _Entity___get_id__impl__z2xerk($this) {
    return $this;
  }
  function Companion_0() {
    Companion_instance_0 = this;
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new InlineClassDescriptor('com.github.quillraven.fleks.Entity', this);
    tmp0_serialDesc.aei('id', false);
    this.sf3_1 = tmp0_serialDesc;
  }
  protoOf($serializer).tf3 = function (encoder, value) {
    var tmp0_inlineEncoder = encoder.kec(this.sf3_1);
    if (tmp0_inlineEncoder == null)
      null;
    else {
      tmp0_inlineEncoder.eec(_Entity___get_id__impl__z2xerk(value));
    }
  };
  protoOf($serializer).le8 = function (encoder, value) {
    return this.tf3(encoder, value instanceof Entity ? value.wf2_1 : THROW_CCE());
  };
  protoOf($serializer).uf3 = function (decoder) {
    return _Entity___init__impl__fl94im(decoder.deb(this.sf3_1).xea());
  };
  protoOf($serializer).me8 = function (decoder) {
    return new Entity(this.uf3(decoder));
  };
  protoOf($serializer).ke8 = function () {
    return this.sf3_1;
  };
  protoOf($serializer).cei = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function Entity__equals_impl_spz3x1($this, other) {
    if (!(other instanceof Entity))
      return false;
    if (!($this === (other instanceof Entity ? other.wf2_1 : THROW_CCE())))
      return false;
    return true;
  }
  function Entity__hashCode_impl_eg09xr($this) {
    return $this;
  }
  function Entity__toString_impl_ytxv8i($this) {
    return 'Entity(id=' + $this + ')';
  }
  function Entity(id) {
    Companion_getInstance_0();
    this.wf2_1 = id;
  }
  protoOf(Entity).equals = function (other) {
    return Entity__equals_impl_spz3x1(this.wf2_1, other);
  };
  protoOf(Entity).hashCode = function () {
    return Entity__hashCode_impl_eg09xr(this.wf2_1);
  };
  protoOf(Entity).toString = function () {
    return Entity__toString_impl_ytxv8i(this.wf2_1);
  };
  function EntityCreateContext(compService, compMasks) {
    EntityComponentContext.call(this, compService);
    this.wf3_1 = compMasks;
  }
  function EntityComponentContext(componentService) {
    this.xf3_1 = componentService;
  }
  protoOf(EntityComponentContext).yf3 = function (_this__u8e3s4) {
    return this.xf3_1.hf3().qf3(_this__u8e3s4);
  };
  function EntityService$cleanupDelays$lambda(this$0) {
    return function (it) {
      this$0.qf3(it.wf2_1);
      return Unit_getInstance();
    };
  }
  function EntityService(world, initialEntityCapacity, entityProvider, compService) {
    entityProvider = entityProvider === VOID ? new DefaultEntityProvider(world, initialEntityCapacity) : entityProvider;
    compService = compService === VOID ? world.xf3_1 : compService;
    this.ff4_1 = world;
    this.gf4_1 = entityProvider;
    this.hf4_1 = compService;
    var tmp = this;
    // Inline function 'com.github.quillraven.fleks.collection.bag' call
    var tmp$ret$0;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp$ret$0 = fillArrayVal(Array(initialEntityCapacity), null);
    tmp.if4_1 = new Bag(tmp$ret$0);
    this.jf4_1 = new EntityCreateContext(this.hf4_1, this.if4_1);
    this.kf4_1 = new EntityUpdateContext(this.hf4_1, this.if4_1);
    this.lf4_1 = false;
    this.mf4_1 = new MutableEntityBag();
    this.nf4_1 = null;
    this.of4_1 = null;
  }
  protoOf(EntityService).gf2 = function () {
    return this.if4_1.gf2();
  };
  protoOf(EntityService).qf3 = function (entity) {
    if (!this.gf4_1.xf2(entity))
      return Unit_getInstance();
    if (this.lf4_1) {
      this.mf4_1.vf2(entity);
    } else {
      this.gf4_1.qf3(entity);
      var compMask = this.if4_1.k(_Entity___get_id__impl__z2xerk(entity));
      var tmp8_safe_receiver = this.of4_1;
      if (tmp8_safe_receiver == null)
        null;
      else
        tmp8_safe_receiver(this.ff4_1, new Entity(entity));
      // Inline function 'com.github.quillraven.fleks.collection.BitArray.forEachSetBit' call
      var inductionVariable = compMask.jf2_1.length - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var word = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var bitsAtWord = compMask.jf2_1[word];
          if (!bitsAtWord.equals(new Long(0, 0))) {
            var w = word << 6;
            var inductionVariable_0 = 63;
            if (0 <= inductionVariable_0)
              do {
                var bit = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + -1 | 0;
                if (!bitsAtWord.ea((new Long(1, 0)).u8(bit)).equals(new Long(0, 0))) {
                  // Inline function 'com.github.quillraven.fleks.EntityService.minusAssign.<anonymous>' call
                  var tmp0_anonymous = w + bit | 0;
                  this.hf4_1.jf3(tmp0_anonymous).qf3(entity);
                }
              }
               while (0 <= inductionVariable_0);
          }
        }
         while (0 <= inductionVariable);
      compMask.nf2();
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = this.ff4_1.df4_1;
      var inductionVariable_1 = 0;
      var last = indexedObject.length;
      while (inductionVariable_1 < last) {
        var element = indexedObject[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.EntityService.minusAssign.<anonymous>' call
        element.bf5(entity);
      }
    }
  };
  protoOf(EntityService).cf5 = function (action) {
    this.gf4_1.cf5(action);
  };
  protoOf(EntityService).df5 = function () {
    this.lf4_1 = false;
    if (this.mf4_1.k17()) {
      this.mf4_1.bf3(EntityService$cleanupDelays$lambda(this));
      this.mf4_1.y2();
    }
  };
  function EntityUpdateContext(compService, compMasks) {
    EntityCreateContext.call(this, compService, compMasks);
  }
  function DefaultEntityProvider(world, initialEntityCapacity) {
    this.ef5_1 = world;
    this.ff5_1 = 0;
    this.gf5_1 = new BitArray(initialEntityCapacity);
    this.hf5_1 = ArrayDeque_init_$Create$();
  }
  protoOf(DefaultEntityProvider).if5 = function () {
    var tmp;
    if (this.hf5_1.l()) {
      var _unary__edvuaz = this.ff5_1;
      this.ff5_1 = _unary__edvuaz + 1 | 0;
      tmp = _Entity___init__impl__fl94im(_unary__edvuaz);
    } else {
      var recycled = this.hf5_1.t2().wf2_1;
      this.gf5_1.r7m(_Entity___get_id__impl__z2xerk(recycled));
      if (_Entity___get_id__impl__z2xerk(recycled) >= this.ff5_1) {
        this.ff5_1 = _Entity___get_id__impl__z2xerk(recycled) + 1 | 0;
      }
      tmp = recycled;
    }
    return tmp;
  };
  protoOf(DefaultEntityProvider).qf3 = function (entity) {
    this.hf5_1.b(new Entity(entity));
    this.gf5_1.mf2(_Entity___get_id__impl__z2xerk(entity));
  };
  protoOf(DefaultEntityProvider).xf2 = function (entity) {
    var tmp;
    var containsUpper = this.ff5_1;
    var containsArg = _Entity___get_id__impl__z2xerk(entity);
    if (0 <= containsArg ? containsArg < containsUpper : false) {
      tmp = !this.gf5_1.k(_Entity___get_id__impl__z2xerk(entity));
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(DefaultEntityProvider).cf5 = function (action) {
    var inductionVariable = 0;
    var last = this.ff5_1;
    if (inductionVariable < last)
      $l$loop: do {
        var id = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var entity = _Entity___init__impl__fl94im(id);
        if (this.gf5_1.k(_Entity___get_id__impl__z2xerk(entity)))
          continue $l$loop;
        action(this.ef5_1, new Entity(entity));
      }
       while (inductionVariable < last);
  };
  function FleksHookAlreadyAddedException(hookType, objType) {
    FleksException.call(this, hookType + ' for ' + objType + ' already available!');
    captureStack(this, FleksHookAlreadyAddedException);
  }
  function FleksFamilyException(familyDefinition) {
    FleksException.call(this, 'Family must have at least one of allOf, noneOf or anyOf. Definition: ' + familyDefinition + '}');
    captureStack(this, FleksFamilyException);
  }
  function FleksWrongConfigurationUsageException() {
    FleksException.call(this, "The global functions 'inject' and 'family' must be used inside a WorldConfiguration scope.The same applies for 'compareEntityBy' and 'compareEntity' unless you specify the world parameter explicitly.");
    captureStack(this, FleksWrongConfigurationUsageException);
  }
  function FleksSystemAlreadyAddedException(system) {
    FleksException.call(this, "System '" + system.ue() + "' is already part of the '" + getKClass(WorldConfiguration).ue() + "'.");
    captureStack(this, FleksSystemAlreadyAddedException);
  }
  function FleksNoSuchEntityComponentException(entity, component) {
    FleksException.call(this, "Entity '" + new Entity(entity) + "' has no component of type '" + component + "'.");
    captureStack(this, FleksNoSuchEntityComponentException);
  }
  function FleksException(message) {
    RuntimeException_init_$Init$(message, this);
    captureStack(this, FleksException);
  }
  function Family(allOf, noneOf, anyOf, world, entityService) {
    allOf = allOf === VOID ? null : allOf;
    noneOf = noneOf === VOID ? null : noneOf;
    anyOf = anyOf === VOID ? null : anyOf;
    entityService = entityService === VOID ? world.cf4_1 : entityService;
    EntityComponentContext.call(this, world.xf3_1);
    this.qf4_1 = allOf;
    this.rf4_1 = noneOf;
    this.sf4_1 = anyOf;
    this.tf4_1 = world;
    this.uf4_1 = entityService;
    this.vf4_1 = null;
    this.wf4_1 = null;
    this.xf4_1 = new BitArray(this.tf4_1.gf2());
    this.yf4_1 = false;
    this.zf4_1 = new MutableEntityBag();
    this.af5_1 = false;
  }
  protoOf(Family).jf5 = function () {
    if (this.af5_1 ? !this.yf4_1 : false) {
      this.af5_1 = false;
      this.xf4_1.sf2(this.zf4_1);
    }
    return this.zf4_1;
  };
  protoOf(Family).kf5 = function () {
    return this.xf4_1.rf2();
  };
  protoOf(Family).pf2 = function (compMask) {
    return ((this.qf4_1 == null ? true : compMask.pf2(this.qf4_1)) ? this.rf4_1 == null ? true : !compMask.of2(this.rf4_1) : false) ? this.sf4_1 == null ? true : compMask.of2(this.sf4_1) : false;
  };
  protoOf(Family).yf2 = function (comparator) {
    return this.jf5().yf2(comparator);
  };
  protoOf(Family).lf5 = function (entity, compMask) {
    if (this.pf2(compMask)) {
      this.af5_1 = true;
      this.xf4_1.mf2(_Entity___get_id__impl__z2xerk(entity));
      var tmp9_safe_receiver = this.vf4_1;
      if (tmp9_safe_receiver == null)
        null;
      else
        tmp9_safe_receiver(this.tf4_1, new Entity(entity));
    }
  };
  protoOf(Family).mf5 = function (entity, compMask) {
    var entityInFamily = this.pf2(compMask);
    if (entityInFamily ? !this.xf4_1.k(_Entity___get_id__impl__z2xerk(entity)) : false) {
      this.af5_1 = true;
      this.xf4_1.mf2(_Entity___get_id__impl__z2xerk(entity));
      var tmp10_safe_receiver = this.vf4_1;
      if (tmp10_safe_receiver == null)
        null;
      else
        tmp10_safe_receiver(this.tf4_1, new Entity(entity));
    } else if (!entityInFamily ? this.xf4_1.k(_Entity___get_id__impl__z2xerk(entity)) : false) {
      this.af5_1 = true;
      this.xf4_1.r7m(_Entity___get_id__impl__z2xerk(entity));
      var tmp11_safe_receiver = this.wf4_1;
      if (tmp11_safe_receiver == null)
        null;
      else
        tmp11_safe_receiver(this.tf4_1, new Entity(entity));
    }
  };
  protoOf(Family).bf5 = function (entity) {
    if (this.xf4_1.k(_Entity___get_id__impl__z2xerk(entity))) {
      this.af5_1 = true;
      this.xf4_1.r7m(_Entity___get_id__impl__z2xerk(entity));
      var tmp12_safe_receiver = this.wf4_1;
      if (tmp12_safe_receiver == null)
        null;
      else
        tmp12_safe_receiver(this.tf4_1, new Entity(entity));
    }
  };
  protoOf(Family).toString = function () {
    return 'Family(allOf=' + this.qf4_1 + ', noneOf=' + this.rf4_1 + ', anyOf=' + this.sf4_1 + ', numEntities=' + this.kf5() + ')';
  };
  protoOf(Family).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Family))
      return false;
    var tmp0_other_with_cast = other instanceof Family ? other : THROW_CCE();
    if (!equals(this.qf4_1, tmp0_other_with_cast.qf4_1))
      return false;
    if (!equals(this.rf4_1, tmp0_other_with_cast.rf4_1))
      return false;
    if (!equals(this.sf4_1, tmp0_other_with_cast.sf4_1))
      return false;
    if (!equals(this.tf4_1, tmp0_other_with_cast.tf4_1))
      return false;
    if (!equals(this.uf4_1, tmp0_other_with_cast.uf4_1))
      return false;
    return true;
  };
  protoOf(Family).hashCode = function () {
    var result = this.qf4_1 == null ? 0 : this.qf4_1.hashCode();
    result = imul(result, 31) + (this.rf4_1 == null ? 0 : this.rf4_1.hashCode()) | 0;
    result = imul(result, 31) + (this.sf4_1 == null ? 0 : this.sf4_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.tf4_1) | 0;
    result = imul(result, 31) + hashCode(this.uf4_1) | 0;
    return result;
  };
  function FamilyDefinition(allOf, noneOf, anyOf) {
    allOf = allOf === VOID ? null : allOf;
    noneOf = noneOf === VOID ? null : noneOf;
    anyOf = anyOf === VOID ? null : anyOf;
    this.nf5_1 = allOf;
    this.of5_1 = noneOf;
    this.pf5_1 = anyOf;
  }
  protoOf(FamilyDefinition).qf5 = function (types) {
    var tmp = this;
    // Inline function 'kotlin.also' call
    var tmp0_also = new BitArray(types.length);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.github.quillraven.fleks.FamilyDefinition.all.<anonymous>' call
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = types.length;
    while (inductionVariable < last) {
      var element = types[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.github.quillraven.fleks.FamilyDefinition.all.<anonymous>.<anonymous>' call
      tmp0_also.mf2(element.ef3_1);
    }
    tmp.nf5_1 = tmp0_also;
    return this;
  };
  protoOf(FamilyDefinition).l = function () {
    return (isNullOrEmpty(this.nf5_1) ? isNullOrEmpty(this.of5_1) : false) ? isNullOrEmpty(this.pf5_1) : false;
  };
  protoOf(FamilyDefinition).e4 = function () {
    return this.nf5_1;
  };
  protoOf(FamilyDefinition).f4 = function () {
    return this.of5_1;
  };
  protoOf(FamilyDefinition).o9 = function () {
    return this.pf5_1;
  };
  protoOf(FamilyDefinition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FamilyDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof FamilyDefinition ? other : THROW_CCE();
    if (!equals(this.nf5_1, tmp0_other_with_cast.nf5_1))
      return false;
    if (!equals(this.of5_1, tmp0_other_with_cast.of5_1))
      return false;
    if (!equals(this.pf5_1, tmp0_other_with_cast.pf5_1))
      return false;
    return true;
  };
  protoOf(FamilyDefinition).hashCode = function () {
    var result = this.nf5_1 == null ? 0 : this.nf5_1.hashCode();
    result = imul(result, 31) + (this.of5_1 == null ? 0 : this.of5_1.hashCode()) | 0;
    result = imul(result, 31) + (this.pf5_1 == null ? 0 : this.pf5_1.hashCode()) | 0;
    return result;
  };
  protoOf(FamilyDefinition).toString = function () {
    return 'FamilyDefinition(allOf=' + this.nf5_1 + ', noneOf=' + this.of5_1 + ', anyOf=' + this.pf5_1 + ')';
  };
  function IteratingSystem$Companion$EMPTY_COMPARATOR$1() {
  }
  protoOf(IteratingSystem$Companion$EMPTY_COMPARATOR$1).cf3 = function (entityA, entityB) {
    return 0;
  };
  function Companion_1() {
    Companion_instance_1 = this;
    var tmp = this;
    tmp.rf5_1 = new IteratingSystem$Companion$EMPTY_COMPARATOR$1();
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function IteratingSystem$onTick$lambda(this$0) {
    return function (it) {
      this$0.bf6(it.wf2_1);
      return Unit_getInstance();
    };
  }
  function IteratingSystem$onTick$lambda_0(this$0) {
    return function (it) {
      this$0.bf6(it.wf2_1);
      return Unit_getInstance();
    };
  }
  function IteratingSystem$onAlpha$lambda(this$0, $alpha) {
    return function (it) {
      this$0.cf6(it.wf2_1, $alpha);
      return Unit_getInstance();
    };
  }
  function IteratingSystem$onAlpha$lambda_0(this$0, $alpha) {
    return function (it) {
      this$0.cf6(it.wf2_1, $alpha);
      return Unit_getInstance();
    };
  }
  function IteratingSystem(family, comparator, sortingType, interval, enabled) {
    Companion_getInstance_1();
    comparator = comparator === VOID ? Companion_getInstance_1().rf5_1 : comparator;
    sortingType = sortingType === VOID ? Automatic_getInstance() : sortingType;
    interval = interval === VOID ? EachFrame_getInstance() : interval;
    enabled = enabled === VOID ? true : enabled;
    IntervalSystem.call(this, interval, enabled);
    this.xf5_1 = family;
    this.yf5_1 = comparator;
    this.zf5_1 = sortingType;
    this.af6_1 = equals(this.zf5_1, Automatic_getInstance()) ? !equals(this.yf5_1, Companion_getInstance_1().rf5_1) : false;
  }
  protoOf(IteratingSystem).df6 = function () {
    if (this.af6_1) {
      this.af6_1 = equals(this.zf5_1, Automatic_getInstance());
      this.xf5_1.yf2(this.yf5_1);
    }
    // Inline function 'com.github.quillraven.fleks.Family.forEach' call
    var tmp0_forEach = this.xf5_1;
    var entitiesForIteration = tmp0_forEach.jf5();
    if (!tmp0_forEach.uf4_1.lf4_1) {
      tmp0_forEach.uf4_1.lf4_1 = true;
      tmp0_forEach.yf4_1 = true;
      entitiesForIteration.bf3(IteratingSystem$onTick$lambda(this));
      tmp0_forEach.yf4_1 = false;
      tmp0_forEach.uf4_1.df5();
    } else {
      tmp0_forEach.yf4_1 = true;
      entitiesForIteration.bf3(IteratingSystem$onTick$lambda_0(this));
      tmp0_forEach.yf4_1 = false;
    }
  };
  protoOf(IteratingSystem).ef6 = function (alpha) {
    // Inline function 'com.github.quillraven.fleks.Family.forEach' call
    var tmp0_forEach = this.xf5_1;
    var entitiesForIteration = tmp0_forEach.jf5();
    if (!tmp0_forEach.uf4_1.lf4_1) {
      tmp0_forEach.uf4_1.lf4_1 = true;
      tmp0_forEach.yf4_1 = true;
      entitiesForIteration.bf3(IteratingSystem$onAlpha$lambda(this, alpha));
      tmp0_forEach.yf4_1 = false;
      tmp0_forEach.uf4_1.df5();
    } else {
      tmp0_forEach.yf4_1 = true;
      entitiesForIteration.bf3(IteratingSystem$onAlpha$lambda_0(this, alpha));
      tmp0_forEach.yf4_1 = false;
    }
  };
  protoOf(IteratingSystem).cf6 = function (entity, alpha) {
    return Unit_getInstance();
  };
  function EachFrame() {
    EachFrame_instance = this;
  }
  var EachFrame_instance;
  function EachFrame_getInstance() {
    if (EachFrame_instance == null)
      new EachFrame();
    return EachFrame_instance;
  }
  function IntervalSystem(interval, enabled, world) {
    interval = interval === VOID ? EachFrame_getInstance() : interval;
    enabled = enabled === VOID ? true : enabled;
    var tmp;
    if (world === VOID) {
      var _elvis__6sfipt = Companion_getInstance_2().lf6_1;
      var tmp_0;
      if (_elvis__6sfipt == null) {
        throw new FleksWrongConfigurationUsageException();
      } else {
        tmp_0 = _elvis__6sfipt;
      }
      tmp = tmp_0;
    } else {
      tmp = world;
    }
    world = tmp;
    EntityComponentContext.call(this, world.xf3_1);
    this.gf6_1 = interval;
    this.hf6_1 = enabled;
    this.if6_1 = world;
    this.jf6_1 = 0.0;
  }
  protoOf(IntervalSystem).mf6 = function () {
    var tmp;
    var tmp_0 = this.gf6_1;
    if (tmp_0 instanceof Fixed) {
      tmp = this.gf6_1.nf6_1;
    } else {
      tmp = this.if6_1.bf4_1;
    }
    return tmp;
  };
  protoOf(IntervalSystem).kf6 = function () {
    var tmp13_subject = this.gf6_1;
    if (tmp13_subject instanceof EachFrame) {
      this.df6();
    } else {
      if (tmp13_subject instanceof Fixed) {
        this.jf6_1 = this.jf6_1 + this.if6_1.bf4_1;
        var stepRate = this.gf6_1.nf6_1;
        while (this.jf6_1 >= stepRate) {
          this.df6();
          this.jf6_1 = this.jf6_1 - stepRate;
        }
        this.ef6(this.jf6_1 / stepRate);
      } else {
        noWhenBranchMatchedException();
      }
    }
  };
  protoOf(IntervalSystem).ef6 = function (alpha) {
    return Unit_getInstance();
  };
  function Automatic() {
    Automatic_instance = this;
  }
  var Automatic_instance;
  function Automatic_getInstance() {
    if (Automatic_instance == null)
      new Automatic();
    return Automatic_instance;
  }
  function Fixed() {
  }
  function Companion_2() {
    Companion_instance_2 = this;
    this.lf6_1 = null;
  }
  protoOf(Companion_2).of6 = function (cfg) {
    var tmp19_safe_receiver = this.lf6_1;
    var _elvis__6sfipt = tmp19_safe_receiver == null ? null : tmp19_safe_receiver.of6(cfg);
    var tmp;
    if (_elvis__6sfipt == null) {
      throw new FleksWrongConfigurationUsageException();
    } else {
      tmp = _elvis__6sfipt;
    }
    return tmp;
  };
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function World$family$lambda($family) {
    return function ($this$forEach, it) {
      $family._v.mf5(it.wf2_1, $this$forEach.cf4_1.if4_1.k(_Entity___get_id__impl__z2xerk(it.wf2_1)));
      return Unit_getInstance();
    };
  }
  function World(entityCapacity) {
    Companion_getInstance_2();
    EntityComponentContext.call(this, new ComponentService());
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.af4_1 = LinkedHashMap_init_$Create$();
    this.bf4_1 = 0.0;
    this.cf4_1 = new EntityService(this, entityCapacity);
    var tmp_0 = this;
    // Inline function 'kotlin.emptyArray' call
    tmp_0.df4_1 = [];
    var tmp_1 = this;
    // Inline function 'kotlin.emptyArray' call
    tmp_1.ef4_1 = [];
    this.xf3_1.ff3_1 = this;
  }
  protoOf(World).gf2 = function () {
    return this.cf4_1.gf2();
  };
  protoOf(World).qf3 = function (entity) {
    this.cf4_1.qf3(entity);
  };
  protoOf(World).of6 = function (cfg) {
    // Inline function 'kotlin.apply' call
    var tmp0_apply = new FamilyDefinition();
    // Inline function 'kotlin.contracts.contract' call
    cfg(tmp0_apply);
    return this.pf6(tmp0_apply);
  };
  protoOf(World).pf6 = function (definition) {
    if (definition.l())
      throw new FleksFamilyException(definition);
    var defAll = definition.e4();
    var defNone = definition.f4();
    var defAny = definition.o9();
    // Inline function 'kotlin.collections.find' call
    var tmp0_find = this.df4_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = tmp0_find.length;
      while (inductionVariable < last) {
        var element = tmp0_find[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.World.family.<anonymous>' call
        if ((equals(element.qf4_1, defAll) ? equals(element.rf4_1, defNone) : false) ? equals(element.sf4_1, defAny) : false) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var family = {_v: tmp$ret$1};
    if (family._v == null) {
      family._v = new Family(defAll, defNone, defAny, this);
      var tmp = this;
      // Inline function 'kotlin.collections.plus' call
      var tmp1_plus = this.df4_1;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$6;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$6 = [family._v];
      tmp.df4_1 = tmp1_plus.concat(tmp$ret$6);
      this.cf4_1.cf5(World$family$lambda(family));
    }
    return family._v;
  };
  protoOf(World).qf6 = function (deltaTime) {
    this.bf4_1 = deltaTime;
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this.ef4_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.github.quillraven.fleks.World.update.<anonymous>' call
      if (element.hf6_1) {
        element.kf6();
      }
    }
  };
  function WorldConfiguration(world) {
    this.rf6_1 = world;
    this.sf6_1 = null;
    this.tf6_1 = null;
    this.uf6_1 = null;
    this.vf6_1 = null;
  }
  protoOf(WorldConfiguration).wf6 = function (cfg) {
    this.tf6_1 = cfg;
  };
  protoOf(WorldConfiguration).xf6 = function (cfg) {
    this.vf6_1 = cfg;
  };
  protoOf(WorldConfiguration).yf6 = function () {
    var tmp14_safe_receiver = this.sf6_1;
    if (tmp14_safe_receiver == null)
      null;
    else
      tmp14_safe_receiver(new InjectableConfiguration(this.rf6_1));
    var tmp15_safe_receiver = this.tf6_1;
    if (tmp15_safe_receiver == null)
      null;
    else
      tmp15_safe_receiver(new ComponentConfiguration(this.rf6_1));
    var tmp16_safe_receiver = this.uf6_1;
    if (tmp16_safe_receiver == null)
      null;
    else
      tmp16_safe_receiver(new FamilyConfiguration(this.rf6_1));
    // Inline function 'kotlin.also' call
    var tmp0_also = new SystemConfiguration();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.github.quillraven.fleks.WorldConfiguration.configure.<anonymous>' call
    var tmp17_safe_receiver = this.vf6_1;
    if (tmp17_safe_receiver == null)
      null;
    else
      tmp17_safe_receiver(tmp0_also);
    var tmp = this.rf6_1;
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp0_toTypedArray = tmp0_also.zf6_1;
    tmp.ef4_1 = copyToArray(tmp0_toTypedArray);
  };
  function configureWorld(entityCapacity, cfg) {
    entityCapacity = entityCapacity === VOID ? 512 : entityCapacity;
    var newWorld = new World(entityCapacity);
    Companion_getInstance_2().lf6_1 = newWorld;
    try {
      // Inline function 'kotlin.apply' call
      var tmp0_apply = new WorldConfiguration(newWorld);
      // Inline function 'kotlin.contracts.contract' call
      cfg(tmp0_apply);
      tmp0_apply.yf6();
    }finally {
      Companion_getInstance_2().lf6_1 = null;
    }
    return newWorld;
  }
  function ComponentConfiguration(world) {
    this.af7_1 = world;
  }
  function SystemConfiguration(systems) {
    var tmp;
    if (systems === VOID) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp = ArrayList_init_$Create$();
    } else {
      tmp = systems;
    }
    systems = tmp;
    this.zf6_1 = systems;
  }
  protoOf(SystemConfiguration).bf7 = function (system) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp0_any = this.zf6_1;
      var tmp;
      if (isInterface(tmp0_any, Collection)) {
        tmp = tmp0_any.l();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var tmp0_iterator = tmp0_any.g();
      while (tmp0_iterator.h()) {
        var element = tmp0_iterator.i();
        // Inline function 'com.github.quillraven.fleks.SystemConfiguration.add.<anonymous>' call
        if (getKClassFromExpression(element).equals(getKClassFromExpression(system))) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    if (tmp$ret$0)
      throw new FleksSystemAlreadyAddedException(getKClassFromExpression(system));
    // Inline function 'kotlin.collections.plusAssign' call
    this.zf6_1.b(system);
  };
  function InjectableConfiguration(world) {
    this.cf7_1 = world;
  }
  function FamilyConfiguration(world) {
    this.df7_1 = world;
  }
  //region block: post-declaration
  protoOf($serializer).dei = typeParametersSerializers;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = BitArray;
  _.$_$.b = ComponentType;
  _.$_$.c = ComponentsHolder;
  _.$_$.d = Entity;
  _.$_$.e = FleksHookAlreadyAddedException;
  _.$_$.f = IteratingSystem;
  _.$_$.g = configureWorld;
  _.$_$.h = _Entity___get_id__impl__z2xerk;
  _.$_$.i = EachFrame_getInstance;
  _.$_$.j = Companion_getInstance_2;
  //endregion
  return _;
}));
